export default [
  {
    path: 'additional-quote',
    name: 'additional-quote',
    component: () => import('@/views/pages/additional-quote/AdditionalQuote.vue'),
    meta: {
      pageTitle: 'Additional quotes',
      breadcrumb: [
        {
          text: 'Additional quotes',
          active: true,
        },
      ],
      resource: 'Additional quote',
    },
  },
]
